import { StringUtils } from '@brunommsilva/react-foundations';
import { Dropdown } from '@brunommsilva/react-foundations';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AccountType } from '../../models/accounts';

interface Props {
  selected?: { id: string; name: string };
  onSelected: (type?: { id: string; name: string }) => void;
}

const AccountTypeDropdown = ({ selected, onSelected }: Props) => {
  const { t } = useTranslation();
  const allOptions = Object.values(AccountType).map((type) => ({
    id: type,
    label: t(`ACCOUNT_TYPE_${type}`),
  }));
  const [options, setOptions] = useState(allOptions);

  const fetchOptions = (search: string) => {
    if (!search) {
      setOptions(allOptions);
      return;
    }

    setOptions(
      allOptions.filter(({ label }) => StringUtils.hasMatch(label, search))
    );
  };

  const handleSelected = (id?: string) => {
    if (!id) {
      onSelected(undefined);
      return;
    }
    onSelected({ id, name: t(`ACCOUNT_TYPE_${id}`) });
  };

  const selectedOption = selected
    ? { id: selected.id, label: selected.name }
    : undefined;

  return (
    <Dropdown
      label={t('ACCOUNT_TYPE')}
      selected={selectedOption}
      onSelected={handleSelected}
      fetchOptions={fetchOptions}
      options={options}
    />
  );
};

export default AccountTypeDropdown;
